module.exports = __webpack_public_path__ + "img/588x310-04.34019800.png";